import I18n from 'I18n';
import { isBusinessUnitId } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
export const BUSINESS_UNIT_NOT_SELECTED = 'businessUnitNotSelected';
export const validateTypePanel = ({
  businessUnitId,
  hasBusinessUnitAccess = false
} = {}) => {
  const isBusinessUnitSelected = isBusinessUnitId(businessUnitId);
  if (hasBusinessUnitAccess && !isBusinessUnitSelected) {
    return BUSINESS_UNIT_NOT_SELECTED;
  } else {
    return null;
  }
};
export const generateTimestampedName = (attemptNumber = 0, name) => {
  const timestamp = I18n.moment.portalTz().format('LL LTS z');
  if (name) {
    return `${name} (${timestamp}) ${attemptNumber > 1 ? `(${attemptNumber})` : ''}`;
  }
  return `${I18n.text('defaultForm.formName', {
    date: `(${timestamp})${attemptNumber > 1 ? ` (${attemptNumber})` : ''}`
  })}`;
};